import React, { Component } from 'react';
import InwardingApiHandler from './../../InwardingApiHandler.js';
import MobLoader from './../../../../commons/MobLoader.js';
import InputFloating from './../../../../commons/InputFloating.js';
import outerBoxImage from './../../../../assets/img/outer-box.png';
import innerBoxImage from './../../../../assets/img/inner-box.png';
import looseUnitsImg from './../../../../assets/img/loose-units.png';
import ErrorBox from './../../../../commons/ErrorBox.js';
import Dialog from '@material-ui/core/Dialog';
import filled_tick from './../../../../assets/img/filled_tick.png';
import close from './../../../../assets/img/close.png';
import offerIcon from './../../../../assets/img/offer_icon.png';
import { sendEventToHevo } from '../../../../utilities/manageEvents.js';

export default class AddMoreQuantity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            gotData: false,
            l1CaseSize: 4,
            l2CaseSize: 20,
            vendorInvoiceLineItemNumber: 3,
            manufacturingDate: 3,
            expiryDate: 20,
            loading: true,
            innerBoxQty: '',
            outerBoxQty: '',
            looseUnits: '',
            showAddDamagedQty: false,
            outerBoxQtyDamaged: '',
            innerBoxQtyDamaged: '',
            looseUnitsDamaged: '',
            product: this.props.location.state.product,
            griProduct: this.props.location.state.griProduct,
            palletId: this.props.location.state.palletId,
            showAddedToPalletBox: false,
            vinv: '',
            countingScreenTimeStarts: 0
        }
    }

    sendEvent = (eventName, eventData) => {
        const { product, vinv, palletId } = this.state;
        if (!eventName || !eventData || !product) {
            console.error('some parameter not passed in event');
            return;
        }
        let req = { ...eventData };
        req["jpin"] = product.productListingInformation ? product.productListingInformation.productInfoResponse.jpin : null;
        req["product_name"] = product.productListingInformation ? product.productListingInformation.productInfoResponse.title : null;
        req["inwarding_session_id"] = vinv ? vinv : null;
        req["gric"] = palletId ? palletId : null;
        req["through_add_more_qty_screen"] = true;
        sendEventToHevo(eventName, req);
    }

    closeError = () => {
        this.setState({ error: null })
    }

    closeAddedToPalletBox = () => {
        this.setState({ showAddedToPalletBox: false });
        this.props.history.push({
            pathname: '/Inwarding/AddPallet/' + this.state.vinv
        })
    }

    dataForProduct(vinv, listingId) {
        let start_time = new Date().getTime();
        this.setState({ loading: true });
        InwardingApiHandler.AddMoreQuantityApi(vinv, listingId)
            .then(resp => {
                const { l1CaseSize, l2CaseSize, vendorInvoiceLineItemNumber, manufacturingDate, expiryDate, vendorInvoiceId, goodsReceivedItemContainerId } = resp;
                let cur_time = new Date().getTime();
                this.setState({
                    gotData: true,
                    l1CaseSize: l1CaseSize,
                    l2CaseSize: l2CaseSize,
                    vendorInvoiceLineItemNumber: vendorInvoiceLineItemNumber,
                    manufacturingDate: manufacturingDate,
                    expiryDate: expiryDate,
                    vinv: vendorInvoiceId,
                    countingScreenTimeStarts: cur_time
                });

                let load_time = ((cur_time - start_time) / 1000).toFixed(2); // in seconds without decimal
                this.sendEvent('ON_LOAD_PRESET_COUNTING_SCREEN', { load_time: Number(load_time), gric: goodsReceivedItemContainerId });

            }).catch(error => {
                this.setState({ error: error.error.error });
            }).finally(() => {
                this.setState({ loading: false });
            })
    }

    componentDidMount() {
        const { product, griProduct } = this.state;
        this.dataForProduct(product.vendorInvoiceId, griProduct.listingDetailsResponse.listingDetails.listingId);
    }

    isItemAbleToAddInPallet = () => {
        const { innerBoxQty, outerBoxQty, looseUnits, outerBoxQtyDamaged, innerBoxQtyDamaged, looseUnitsDamaged } = this.state;
        if (innerBoxQty || outerBoxQty || looseUnits || outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
            return true;
        }

        return false;
    }

    mapEvents = (name, value) => {
        switch (name) {
            case 'outerBoxQty':
                this.sendEvent('ON_ENTER_OUTER_BOX_QUANTITY', { outer_qty: Number(value) });
                break;
            case 'innerBoxQty':
                this.sendEvent('ON_ENTER_INNER_BOX_QUANTITY', { inner_qty: Number(value) });
                break;
            case 'looseUnits':
                this.sendEvent('ON_ENTER_LOOSE_UNITS_QUANTITY', { loose_qty: Number(value) });
                break;
            case 'outerBoxQtyDamaged':
                this.sendEvent('ON_ENTER_OUTER_BOX_DAMAGED_QUANTITY', { damaged_outer_qty: Number(value) });
                break;
            case 'innerBoxQtyDamaged':
                this.sendEvent('ON_ENTER_INNER_BOX_DAMAGED_QUANTITY', { damaged_inner_qty: Number(value) });
                break;
            case 'looseUnitsDamaged':
                this.sendEvent('ON_ENTER_LOOSE_UNITS_DAMAGED_QUANTITY', { damaged_loose_qty: Number(value) });
                break;
            default:
                console.error('random case');
        }
    }

    setNameToValue = (e) => {
        const name = e.target.name;
        let val = e.target.value;

        this.mapEvents(name, val);

        const tar = ["outerBoxQty", "innerBoxQty", "looseUnits", "outerBoxQtyDamaged", "innerBoxQtyDamaged", "looseUnitsDamaged"];
        if (tar.includes(name) && Number(val) < 0) {
            val = 0;
        }

        this.setState({
            [name]: val
        })

    }

    changeDateFormat = (ms) => {
        //change date from milliseconds to 'yyyy-mm-dd'
        let date = new Date(ms);
        let year = date.getFullYear();
        let month = ("0" + (date.getMonth() + 1)).slice(-2);
        let day = ("0" + date.getDate()).slice(-2);

        return `${year}-${month}-${day}`;
    }

    validateQuantity = (totalQty) => {
        // if offer like 'Buy X Get Y' OR 'Buy X Get productTitle Y' exists, then apply validations 
        const mOffer = this.state.griProduct.listingDetailsResponse.listingDetails.manufacturerOffer;

        if (mOffer && mOffer.offerType === "HAS_SEPARATE_ITEMS") {
            let arr = mOffer.title.split(' ');
            if (arr.length === 5) {
                // 'Buy X Get Y Free'
                let x = Number(arr[1]), y = Number(arr[3]);
                if (totalQty % (x + y) !== 0) {
                    this.setState({ error: `Total quantity should be a multiple of ${x} + ${y}` });
                    return false;
                }
            }
            else {
                // 'Buy X Get productTitle Y Free'
                let x = Number(arr[1]);
                if (totalQty % x !== 0) {
                    this.setState({ error: `Total quantity should be a multiple of ${x}` });
                    return false;
                }
            }
        }

        return true;
    }

    addItemToPallet = () => {
        const { griProduct, l1CaseSize, l2CaseSize, manufacturingDate, expiryDate, vendorInvoiceLineItemNumber, product, innerBoxQty, innerBoxQtyDamaged, outerBoxQty, outerBoxQtyDamaged, looseUnits, looseUnitsDamaged, palletId, countingScreenTimeStarts } = this.state;

        let p = griProduct.listingDetailsResponse.listingDetails;
        let req = {};

        if (p.manufacturerOffer) {
            req.freebieJpin = p.manufacturerOffer.offerJPIN;
            let arr = p.manufacturerOffer.title.split(' ');

            if (p.manufacturerOffer.offerType === "HAS_SEPARATE_ITEMS") {
                if (arr.length !== 5) {
                    //buy x get jpinTitle free
                    req.isOutsideProductFreebiePresent = true;
                    if (!req.freebieJpin) {
                        //if no offer jpin, send offer title in freebieJpin, catalog team will understand that it is not catalogued  
                        req.freebieJpin = p.manufacturerOffer.title;
                    }
                }
                else {
                    //buy x get free
                    req.isSameProductFreebie = true;
                }
            }
        }

        req.vendorInvoiceId = product.vendorInvoiceId;
        req.listingId = griProduct.listingDetailsResponse.listingDetails.listingId;
        req.jpin = product.productListingInformation.productInfoResponse.jpin;
        req.expectedListingId = product.productListingInformation.listingId;
        req.listingIdentificationType = req.listingId === req.expectedListingId ? 'LISTING_MATCHED' : 'LISTING_MISMATCHED_EXISTING';
        req.expectedProductBarcode = product.productListingInformation.productInfoResponse.ean;
        // req.labelCodeMatchStatus = barcodeMatchStatus;
        // req.scannedProductLabelCode = scannedBarcode;
        req.goodsReceivingContainerId = palletId;

        req.manufacturingDate = new Date(manufacturingDate).getTime();
        req.expiryDate = new Date(expiryDate).getTime();

        req.vendorInvoiceLineItemNumber = vendorInvoiceLineItemNumber;
        req.l1CaseSize = '' + l1CaseSize;
        req.l2CaseSize = '' + l2CaseSize;

        let goodQty = 0, badQty = 0, innerBoxes = -1;
        if (l2CaseSize > 0 && l1CaseSize > 0) {
            innerBoxes = l2CaseSize / l1CaseSize;
        }
        let total = (innerBoxes <= 0) ? l1CaseSize : l1CaseSize * innerBoxes;

        if (outerBoxQty || innerBoxQty || looseUnits) {
            goodQty = (total * outerBoxQty) + (l1CaseSize * innerBoxQty) + (1 * looseUnits);
        }

        if (outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
            badQty = (total * outerBoxQtyDamaged) + (l1CaseSize * innerBoxQtyDamaged) + (1 * looseUnitsDamaged);
        }

        req.nonDamagedQty = goodQty;
        req.damagedQty = badQty;
        req.qty = goodQty + badQty;

        let req2 = {};
        req2['good_qty'] = goodQty;
        req2['damaged_qty'] = badQty;
        req2['mrp'] = product.productListingInformation.mrp;
        this.sendEvent('ON_CLICK_TAG_TO_PALLET', req2);

        if (!this.validateQuantity(goodQty + badQty)) {
            return;
        }

        this.setState({ loading: true });
        InwardingApiHandler.addToPallet(req)
            .then(resp => {
                let time_taken_on_counting_screen = ((new Date().getTime() - countingScreenTimeStarts) / 1000).toFixed(0); // in seconds without decimal
                this.sendEvent('TIME_TAKEN_ON_COUNTING_SCREEN', { duration: Number(time_taken_on_counting_screen) });

                this.setState({ showAddedToPalletBox: true });
            }).catch(error => {
                this.setState({ error: error.error.error });
            }).finally(() => {
                this.setState({ loading: false });
            })
    }

    resetDamagedParameters = () => {
        const { showAddDamagedQty } = this.state;
        this.setState({
            showAddDamagedQty: !showAddDamagedQty,
            damageReasonType: null,
            outerBoxQtyDamaged: '',
            innerBoxQtyDamaged: '',
            looseUnitsDamaged: ''
        })
    }

    buyXgetYnote = () => {
        const mOffer = this.state.griProduct.listingDetailsResponse.listingDetails.manufacturerOffer;
        if (mOffer && mOffer.offerType === "HAS_SEPARATE_ITEMS") {
            let arr = mOffer.title.split(' ');
            if (arr.length === 5) {
                // 'Buy X Get Y Free'
                return (
                    <div style={{ backgroundColor: '#F7F4CB', padding: '10px', color: '#BD2E23', marginTop: '8px' }}>Note: Count parent and freebie together for this case</div>
                )
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

    showEnterInwardingDetails = () => {
        const { griProduct, innerBoxQty, outerBoxQty, looseUnits, showAddDamagedQty, outerBoxQtyDamaged, innerBoxQtyDamaged, looseUnitsDamaged, l1CaseSize, l2CaseSize, vendorInvoiceLineItemNumber, manufacturingDate, expiryDate, gotData } = this.state;

        if (!gotData) return null;

        let mfg = this.changeDateFormat(manufacturingDate), exp = this.changeDateFormat(expiryDate);

        let goodQty = 0, badQty = 0, innerBoxes = -1;
        if (l2CaseSize > 0 && l1CaseSize > 0) {
            innerBoxes = l2CaseSize / l1CaseSize;
        }
        let total = (innerBoxes <= 0) ? l1CaseSize : l1CaseSize * innerBoxes;

        if (outerBoxQty || innerBoxQty || looseUnits) {
            goodQty = (total * outerBoxQty) + (l1CaseSize * innerBoxQty) + (1 * looseUnits);
        }

        if (outerBoxQtyDamaged || innerBoxQtyDamaged || looseUnitsDamaged) {
            badQty = (total * outerBoxQtyDamaged) + (l1CaseSize * innerBoxQtyDamaged) + (1 * looseUnitsDamaged);
        }

        return (<div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className={this.isItemAbleToAddInPallet() ? "lw-btn dtl-box" : "dtl-box"} style={{ padding: '10px 15px', maxWidth: '700px', width: '100%' }}>
                <div>
                    <div className="row">
                        <div className="col-xs-4" style={{ textAlign: 'center' }}>
                            <img src={griProduct.productInfoResponse.imageUrls[0].thumbnail} style={{ maxWidth: '100%', maxHeight: '100px' }} alt="product" />
                        </div>
                        <div className="col-xs-8 no-left-padding">
                            {
                                // <div className="l-imp-txt">{product.productInfoResponse.jpin}</div>
                            }
                            <div className="v-imp-txt top-ten">{griProduct.productInfoResponse.title}</div>
                            <div className="pr-mrp top-ten">MRP {griProduct.listingDetailsResponse.listingDetails.mrp}</div>
                        </div>
                    </div>
                    {(griProduct.listingDetailsResponse.listingDetails.manufacturerOffer) ?
                        <div style={{ padding: '10px 0' }}>
                            <img src={offerIcon} alt="offer" /> {griProduct.listingDetailsResponse.listingDetails.manufacturerOffer.title}
                        </div> : null
                    }

                    {this.buyXgetYnote()}

                    <div style={{ borderBottom: '2px solid #dfdfdf', marginTop: '10px' }}></div>
                </div>

                <div className="top-twenty" style={{ opacity: '0.6' }}>
                    <InputFloating type="number" label="Vendor Invoice Line Item Number" name="vendorInvoiceLineItemNumber" value={vendorInvoiceLineItemNumber} disabled={true} />
                </div>

                <div className="top-twenty" style={{ maxWidth: '500px', opacity: '0.6' }}>
                    <div className="v-imp-txt" style={{ marginBottom: '14px', fontWeight: '700' }}>Case Size Details</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className="centralized">
                            <div>
                                <span>1</span><img src={outerBoxImage} className="small-image" alt='L1' />
                            </div>
                            <div>Outer Box</div>
                        </div>
                        <div>has</div>
                        {(innerBoxes !== -1) ?
                            <React.Fragment>
                                <div className="centralized">
                                    <div>
                                        <input type='number' className='small-input2' name="innerBoxes" value={innerBoxes} disabled={true} /><img src={innerBoxImage} className="small-image" alt='L2' />
                                    </div>
                                    <div>Inner Box</div>
                                </div>
                                <div>with</div>
                            </React.Fragment>
                            :
                            null
                        }
                        <div className="centralized">
                            <div>
                                <input type='number' className='small-input2' name="l1CaseSize" value={l1CaseSize} disabled={true} /><img src={looseUnitsImg} className="small-image" alt='loose units' />
                            </div>
                            <div>Units</div>
                        </div>
                        <div>=</div>
                        <div className="centralized">
                            <div>{total}</div>
                            <div>Total Units</div>
                        </div>
                    </div>
                </div>

                <div className="top-twenty" style={{ maxWidth: '600px' }}>
                    {/* <div className="v-imp-txt" style={{ fontWeight: '500', textAlign: 'center', color: 'green', border: '1px solid #BFBFBF', borderBottom: 'none', padding: '7px' }}>{inwardedQuantity} Units already received</div> */}
                    <div className="v-imp-txt" style={{ fontWeight: '700', textAlign: 'center', border: '1px solid #BFBFBF', borderBottom: 'none', padding: '7px' }}>Good Quantity Received</div>
                    <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF', borderBottom: 'none', }} >
                        <div className='centralized2'>Outer Box</div>
                        <div className='centralized2'>Inner Box</div>
                        <div className='centralized2'>Loose Units</div>
                        <div className='centralized2'>Total Units</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF' }} >
                        <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                            <input type='number' className='small-input-cs' name="outerBoxQty" value={outerBoxQty} onChange={(e) => { this.setNameToValue(e) }} />
                        </div>
                        <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                            {(Number(innerBoxes) > 0) ?
                                <input type='number' className='small-input-cs' name="innerBoxQty" value={innerBoxQty} onChange={(e) => { this.setNameToValue(e) }} />
                                :
                                <div>-</div>
                            }
                        </div>
                        <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                            <input type='number' className='small-input-cs' name="looseUnits" value={looseUnits} onChange={(e) => { this.setNameToValue(e) }} />
                        </div>
                        <div className='centralized2' >
                            {goodQty}
                        </div>
                    </div>
                </div>


                {(showAddDamagedQty) ?
                    <div style={{ maxWidth: '600px' }}>
                        <div className="v-imp-txt" style={{ fontWeight: '700', textAlign: 'center', border: '1px solid #BFBFBF', borderTop: 'none', borderBottom: 'none', padding: '7px' }}>Damaged Quantity received</div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF', borderBottom: 'none', }} >
                            <div className='centralized2'>Outer Box</div>
                            <div className='centralized2'>Inner Box</div>
                            <div className='centralized2'>Loose Units</div>
                            <div className='centralized2'>Total Units</div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-around', border: '1px solid #BFBFBF' }} >
                            <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                <input type='number' className='small-input-cs' name="outerBoxQtyDamaged" value={outerBoxQtyDamaged} onChange={(e) => { this.setNameToValue(e) }} />
                            </div>
                            <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                {(Number(innerBoxes) > 0) ?
                                    <input type='number' className='small-input-cs' name="innerBoxQtyDamaged" value={innerBoxQtyDamaged} onChange={(e) => { this.setNameToValue(e) }} />
                                    :
                                    <div>-</div>
                                }
                            </div>
                            <div className='centralized2' style={{ borderRight: '1px solid rgb(191,191,191)' }}>
                                <input type='number' className='small-input-cs' name="looseUnitsDamaged" value={looseUnitsDamaged} onChange={(e) => { this.setNameToValue(e) }} />
                            </div>
                            <div className='centralized2' >
                                {badQty}
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-around', margin: '5px 0px', fontSize: '16px', fontWeight: '600' }}>
                            <div className='centralized2'></div>
                            <div className='centralized2' style={{ width: '50%' }}>
                                <div>Total quantity:</div>
                                <div>(as per invoice)</div>
                            </div>
                            <div className='centralized2'>{goodQty + badQty}</div>
                        </div>
                        <hr style={{ borderColor: 'black', marginTop: '2px' }} />

                        {/* <div className="top-twenty" style={{ textDecoration: 'underline', color: '#ff810a', cursor: 'pointer' }} onClick={this.resetDamagedParameters}>- No Damaged quantity</div> */}
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button className="btn btn-warning" style={{ cursor: 'pointer' }} onClick={this.resetDamagedParameters}>
                                - No Damaged quantity
                            </button>
                        </div>
                    </div>
                    :
                    // <div className="top-twenty" style={{ textDecoration: 'underline', color: '#2891E1', cursor: 'pointer' }} onClick={() => { this.setState({ showAddDamagedQty: !showAddDamagedQty }) }}>
                    //     + Add Damaged Quantity (if any)
                    // </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button className="btn btn-info top-twenty" style={{ cursor: 'pointer' }} onClick={() => { this.setState({ showAddDamagedQty: !showAddDamagedQty }); this.sendEvent('ON_CLICK_ADD_DAMAGED_RECEIVED_QUANTITY', {}) }}>
                            + Add Damaged Quantity (if any)
                        </button>
                    </div>
                }

                <div className="top-twenty" style={{ display: 'flex', flexWrap: 'wrap', opacity: '0.6' }}>
                    <div style={{ width: '300px', margin: '5px 30px' }}>
                        <InputFloating type="date" label="Manufacturing Date" name="manufacturingDate" value={mfg} disabled={true} />

                    </div>
                    <div style={{ width: '300px', margin: '5px 30px' }}>
                        <InputFloating type="date" label="Expiry Date" name="expiryDate" value={exp} disabled={true} />
                    </div>
                </div>
            </div>
            {(this.isItemAbleToAddInPallet()) ?
                <div className="bottom-btn">
                    <button className="btn btn-big-fin" onClick={this.addItemToPallet}>Tag to Pallet</button>
                </div> : null
            }
        </div>
        )
    }

    getHeader = () => {
        return (
            <div className="header-name-bar">
                <div className="row">
                    <div className="col-xs-1">
                        <div className="visible-xs visible-sm" style={{ lineHeight: '65px', fontSize: '25px' }} onClick={() => { this.props.history.goBack(); }}><i className="fas fa-arrow-left"></i></div>
                    </div>
                    <div className="col-xs-11">
                        <div className="header-page-name">Product Details</div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { error, loading, showAddedToPalletBox } = this.state;
        return (
            <div>
                {this.getHeader()}
                {this.showEnterInwardingDetails()}
                {(error) ?
                    <ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
                }
                {(loading) ?
                    <MobLoader /> : null
                }
                <Dialog open={showAddedToPalletBox} fullWidth={true} onClose={this.closeAddedToPalletBox}>
                    <div style={{ fontSize: '18px', textAlign: 'center', padding: '10px' }}>
                        <div className="text-right" onClick={this.closeAddedToPalletBox}><img src={close} style={{ height: '22px', width: '22px' }} alt="x" /></div>
                        <div className="top-thirty"><img src={filled_tick} alt="success-img" className="top-thirty" style={{ height: '60' }} /></div>
                        <div className="top-thirty"><div className="top-thirty">Product Added To Pallet Successfully</div></div>
                        <div className="top-thirty"><div className="top-twenty"></div></div>
                    </div>
                </Dialog>
            </div>


        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/AddMoreQuantity.js